// extracted by mini-css-extract-plugin
export default {"balance":"balance_balance__geWr-"};